import { Navigate } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'
import coursesBackground from 'modules/upselling_kit/lib/assets/blankSlate/locked-courses-bg.svg'

const Upsell = () => {
  const { getListPath } = useMarketplaceModulesPath()

  const { upsellFlowEnabled } = useEngagementContext()

  if (!upsellFlowEnabled) {
    return <Navigate to={getListPath()} />
  }

  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.enps}
      requestSource="Engagement main tabs"
      requestReason={ValidReasons.MissingAddon}
      background={coursesBackground}
      title={i18n.t('enps.upsell.title')}
      description={i18n.t('enps.upsell.description')}
    />
  )
}

export default Upsell
